<div class="main-section cx-one-ui">
    <div class="form-container cx-one-ui">
        <form [formGroup]="simpleFieldForm" id="reporting-set-data-field">
            <div class="input-field">
                <label for="return-type-dropdown" id="return-type-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Return_Type">RETURN TYPE</label>
                <span class="field-required"> *</span>
                <cxone-singleselect-dropdown id="return-type-dropdown" formControlName="expectedReturnType"
                    [placeholder]="returnTypePlaceholderText" [label]="'label'" [isRequired]="true"
                    (selectionChanged)="returnTypeChangeEvent($event)" [primaryKey]="'id'"
                    [options]="_returnTypeOptions" [showFooter]="false" [sortKey]="'id'" [search]="false">
                </cxone-singleselect-dropdown>
            </div>
            <div class="input-field">
                <label for="field-type-dropdown" id="field-type-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Return">RETURN </label><span class="field-required"> * </span>
                <cxone-singleselect-dropdown id="field-type-dropdown" formControlName="return"
                    (selectionChanged)="selectionChange($event)" [placeholder]="returnPlaceholderText" [label]="'label'"
                    [isRequired]="true" [primaryKey]="'id'" [options]="returnOptions" [showFooter]="false"
                    [sortKey]="'id'" [search]="false">
                </cxone-singleselect-dropdown>
            </div>
            <div class="input-field">
                <label for="feed-dropdown" id="feed-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Select_Feed">SELECT FEED</label><span class="field-required"> * </span>
                <cxone-singleselect-dropdown id="feed-dropdown" formControlName="JoinID"
                    [placeholder]="feedPlaceholderText" [label]="'label'" (selectionChanged)="selectFeedSelection();"
                    [isRequired]="true" [primaryKey]="'id'" [options]="primaryFeedOptions" [showFooter]="false"
                    [search]="false">
                </cxone-singleselect-dropdown>
            </div>
            <ng-container [ngSwitch]="return?.id">
                <ng-container *ngSwitchCase="eReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD">
                    <ng-container *ngTemplateOutlet="feedDropdownInput"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="eReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE">
                    <ng-container *ngTemplateOutlet="defaultValueInputs"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="eReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE">
                    <ng-container *ngTemplateOutlet="feedDropdownInput"></ng-container>
                    <ng-container *ngTemplateOutlet="defaultValueInputs"></ng-container>
                </ng-container>
            </ng-container>
            <ng-template #feedDropdownInput>
                <div class="input-field">
                    <label for="feed-dropdown" id="feed-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Select_Field">Select Field </label><span class="field-required"> * </span>
                    <cxone-singleselect-dropdown id="field-dropdown" formControlName="Field"
                        [placeholder]="fieldPlaceholderText" [label]="'Name'" [isRequired]="true" [primaryKey]="'Name'"
                        [options]="secondaryFeedOptions" [showFooter]="false"
                        (selectionChanged)="selectionChange($event)" [search]="false">
                    </cxone-singleselect-dropdown>
                </div>
            </ng-template>
            <ng-template #defaultValueInputs>
                <div class="input-field">
                    <div class="label-container-with-null-check">
                        <div class="label d-flex align-items-center">
                            <label for="default-value-field" id="default-value-label" cvLocalizedText
                                langSection="ETL_Reporting_Set" langKey="Default_Value"> DEFAULT VALUE</label>
                            <span class="field-required"> * </span>
                            <div class="null-checkbox" *ngIf="isNullCheckboxVisible && simpleFieldReturnType !== eReportingSetReturnTypes.DATE">
                                <ng-container *ngTemplateOutlet="nullCheckBox"></ng-container>
                            </div>
                        </div>
                    </div>
                    <ng-container [ngSwitch]="simpleFieldReturnType">
                        <ng-container *ngSwitchCase="eReportingSetReturnTypes.TEXT">
                            <cxone-text-input type="text" formControlName="DefaultValue" class="report-text-input"
                                [required]="true" [placeholder]="defaultValuePlaceholderText" id="default-value-field">
                            </cxone-text-input>
                        </ng-container>
                        <ng-container *ngSwitchCase="eReportingSetReturnTypes.WHOLE_NUMBER">
                            <div [ngClass]="{'error-class': simpleFieldForm.get('DefaultValue').errors?.invalidValue && employeeContactClickedField === hierarchyGroupName}">
                                <ng-container *ngTemplateOutlet="numericInput"></ng-container>
                            </div>
                            <div *ngIf="simpleFieldForm.get('DefaultValue').errors?.invalidValue && employeeContactClickedField === hierarchyGroupName"
                                class="required">{{simpleFieldForm.get('DefaultValue').errors.invalidValue}}</div>
                        </ng-container>
                        <ng-container *ngSwitchCase="eReportingSetReturnTypes.DECIMAL_NUMBER">
                            <ng-container *ngTemplateOutlet="numericInput"></ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="eReportingSetReturnTypes.DATE">
                            <cxone-date-picker [(ngModel)]="defaultDate" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="notifyValueChanged($event)" [shortDateFormat]="'MMM D, YYYY'"
                                [placement]="'top'" mode="page" [disabled]="isDisableDate">
                            </cxone-date-picker>
                            <div class="date-options">
                                <ng-container *ngTemplateOutlet="nullCheckBox"></ng-container>
                                <ng-container *ngTemplateOutlet="useNowCheckBox"></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="eReportingSetReturnTypes.TRUE_FALSE">
                            <div class="radio-btn-container">
                                <cxone-radio type="radio" value="false" labelText="False" radioId="r9"
                                    formControlName="DefaultValue" name="DefaultValue"></cxone-radio>
                                <cxone-radio type="radio" value="true" labelText="True" radioId="r8"
                                    formControlName="DefaultValue" name="DefaultValue"></cxone-radio>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-template>
            <ng-template #numericInput>
                <cxone-numeric-selector [disabled]="defaultValueControl.disabled" [step]="1" [min]="0" [max]="1000"
                    formControlName="DefaultValue" class="report-text-input"
                    id="default-value-field"></cxone-numeric-selector>
            </ng-template>
            <ng-template #nullCheckBox>
                <cxone-checkbox type="checkbox" labelText="Null" checkboxId="c1" formControlName="IsNull"
                    (change)="handleNullChange()"></cxone-checkbox>
            </ng-template>
            <ng-template #useNowCheckBox>
                <cxone-checkbox type="checkbox" [labelText]="useNowLabelTxt" checkboxId="c2" formControlName="UseNow"
                    (change)="handleUseNowChange()"></cxone-checkbox>
            </ng-template>
        </form>
    </div>
</div>